import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';

import {Individual} from 'src/app/models';

@Component({
    selector: 'app-individual-delete',
    templateUrl: './individual-delete.component.html'
})
export class IndividualDeleteComponent {
    individual: Individual;

    constructor(@Inject(MAT_DIALOG_DATA) public data: any) {
        this.individual = new Individual();
        this.individual.full_name = data.full_name;
    }

}
